define("SDB.SDBLocations.Modal.View", [
  "sdb_sdblocations_template.tpl",
  "SCView",
  "SDB.SDBLocations.Model",
  "Utils",
], function (sdblocations_tpl, SCViewComponent, SDBLocationsModel, Utils) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  /* Build the view constructor with the required properties */
  function SDBLocationsModalView(options) {
    SCView.call(this);

    this.options = options;
    this.template = sdblocations_tpl;
    this.page_header = this.options.pageHeader || this.getTitle();
    this.view = this.options.view;
    this.model = SDBLocationsModel.getInstance();
    this.modalClass = "sdb-locations-modal-view";
    if (this.options.locations && !this.model.getSelectedLocation())
      this.options.locations.forEach(function (location) {
        location.selected = false;
      });

    this.events = {
      'click [data-action="select-experience"]': "handleExperienceClick",
      'click [data-action="select-location"].active': "handleLocationClick",
    };

    this.attributes = {
      id: "SDBLocationsModalViewId",
      class: "sdb-locations-modal-view",
    };

    /* Subscribe the view to the original bootstrap modal events by declaring them again */
    this.listenTo(this, "all", function (eventName) {
      // If the event is close modal from bootstrap, we close the modal in this view
      eventName == "modal-close" && this.closeModal();
    });

    this.on("destroy", this.closeModal.bind(this));
  }

  /* Generate a prototype for the view and add the constructor back */
  SDBLocationsModalView.prototype = Object.create(SCView.prototype);
  SDBLocationsModalView.prototype.constructor = SDBLocationsModalView;

  SDBLocationsModalView.prototype.handleExperienceClick = function (e) {
    var $target = this.$(e.target);
    var experienceType = $target.data("type");

    $('[data-action="select-experience"]').removeClass("active-btn");

    $target.addClass("active-btn"); //added active class to selected one
    this.model.setCookie({ shoppingExperience: experienceType });
    if (experienceType === "online") return this.closeModal();

    var $locationsList = $('[data-role="locations-list-container"]');
    var $locations = $('[data-action="select-location"]');

    $locationsList.removeClass("hide");
    $locations.addClass("active");
  };

  SDBLocationsModalView.prototype.closeModal = function () {
    // var location = this.model.getSelectedLocation();
    // if (!location) this.model.setCookie({ shoppingExperience: "online" });
    var experienceType = this.model.getShoppingExperience();
    if (!experienceType)
      this.model.setCookie({ shoppingExperience: "instore" });
    this.options.container.getLayout()
      ? this.options.container.getLayout().closeModal()
      : null;
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  };

  SDBLocationsModalView.prototype.handleLocationClick = function (e) {
    var $target = this.$(e.target).closest('[data-action="select-location"]');
    var locationId = $target.data("id");

    this.options.locations.forEach(function (location) {
      location.selected = false;
    });

    var location = _.findWhere(this.options.locations, {
      internalid: String(locationId),
    });
    location.selected = true;

    // this.model.setLocations(this.options.locations);
    this.model.setCookie({
      location: location,
      locations: this.options.locations,
    });

    this.closeModal();
  };

  SDBLocationsModalView.prototype.getContext = function () {
    var model = this.model;
    model.set("shoppingExperience", "instore", { silent: true });
    model.setCookie({ shoppingExperience: "instore" });
    var locations = this.filteredLocations || this.options.locations;
    _.each(locations, function (location) {
      model.setLocationSocialMedia(location);
    });
    return {
      title: "Shop The Location Nearest You",
      locations: locations,
      onlyBtns: this.options.onlyBtns ? true : false,
      isMobile: Utils.getDeviceType() === "phone" ? true : false,
      enabledLocations: !!this.model.getSelectedLocation(),
    };
  };

  return SDBLocationsModalView;
});
